import Vue from 'vue'
import Toasted from 'vue-toasted'
Vue.use(Toasted, {
  iconPack: 'custom-class'
})

// options to the toast
const optionsSuccess = {
  className: 'toaster-success',
  containerClass: 'toaster-container',
  duration: 3000,
  icon: 'toast-success-icon',
  action: {
    text: '',
    onClick: (e: any, toastObject: any) => {
      toastObject.goAway(0)
    }
  }
  // icon: '' TODO-OOP: Turns out we have to use material.io icon pack..
}
// register the toast with the custom message
Vue.toasted.register('toast_success',
  (payload) => {
    // if there is a message show it with the message
    return payload.message
  },
  optionsSuccess
)

const optionsError = {
  className: 'toaster-error',
  containerClass: 'toaster-container',
  duration: 7000,
  icon: 'toast-error-icon',
  action: {
    text: '',
    onClick: (e: any, toastObject: any) => {
      toastObject.goAway(0)
    }
  }
}

Vue.toasted.register('toast_error',
  (payload) => {
    // if there is a message show it with the message
    return payload.message
  },
  optionsError
)
